module.exports = __webpack_public_path__ + "media/newstyle/images/format_textdirection_r_to_l-04d4a8d3f635655b5eed8df45edc44c1.svg";